import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import api from "../../api";
import { rebootDeviceUrl } from "../../config";
import { Status } from "../../common/constants";

interface RebootDeviceState {
  apiStatus: string;
  successMessage: string | null;
  errorMessage: string | null;
}

const initialState: RebootDeviceState = {
  apiStatus: Status.IDLE,
  successMessage: null,
  errorMessage: null,
};

export const rebootDevice = createAsyncThunk<
  string,
  { deviceId: string },
  { rejectValue: string }
>("devices/rebootDevice", async ({ deviceId }, { rejectWithValue }) => {
  try {
    const response = await api.post(rebootDeviceUrl, { deviceId });
    return response?.data?.message || "Reboot command sent successfully.";
  } catch (error: any) {
    return rejectWithValue(
      error?.response?.data?.message ||
        "Failed to send reboot command. Please try again."
    );
  }
});

const rebootDeviceSlice = createSlice({
  name: "rebootDevice",
  initialState,
  reducers: {
    resetRebootDeviceState: (state) => {
      state.apiStatus = Status.IDLE;
      state.successMessage = null;
      state.errorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(rebootDevice.pending, (state) => {
        state.apiStatus = Status.PENDING;
        state.successMessage = null;
        state.errorMessage = null;
      })
      .addCase(
        rebootDevice.fulfilled,
        (state, action: PayloadAction<string>) => {
          state.apiStatus = Status.SUCCESS;
          state.successMessage = action.payload;
        }
      )
      .addCase(rebootDevice.rejected, (state, action) => {
        state.apiStatus = Status.FAILED;
        state.errorMessage =
          action.payload || "Failed to send reboot command.";
      });
  },
});

export const { resetRebootDeviceState } = rebootDeviceSlice.actions;
export default rebootDeviceSlice.reducer;